import Styles from './Table.scss';

import Template from './Table.hbs';
import Util from 'util/util'
import InputCell from './InputCell.hbs'
import {generateTemplate} from 'views/components/taskGroups/tasks/tableTemplate/TableUtils'

export default class Template39Table extends BaseView {

    static get validGapTypes() {
        return ['radio', 'checkbox']
    }

    get gapType() {
        const firstGapCell = this.tableData.find((cell) => cell.isGapCell && cell.gapType)
        if (firstGapCell && Template39Table.validGapTypes.includes(firstGapCell.gapType)) {
            return firstGapCell.gapType
        }
        return 'radio'
    }

    get gapCells() {
        return this.tableData.filter((cell) => cell.isGapCell)
    }

    initialize({
        tableData = [],
        response
    }) {

        this.tableData = tableData
        this.response = response

        this.setElement(generateTemplate(Template, Styles, tableData))

        this.setupTable()

    }

    /**
     * Applies content and properties to the table element.
     *
     */
    setupTable() {

        for (const cell of this.tableData) {

            this.applyCellElementStyling(cell)

            this.setCellElementContent(cell)

        }
    }

    /**
     * Get a cell element (TD) from the DOM
     *
     * @param {Number} rowIndex row
     * @param {Number} columnIndex column
     * @returns {HTMLTableCellElement} table cell element
     */
    getCellElement(rowIndex, columnIndex) {
        return this.el.querySelector(`table tr[data-row="${rowIndex}"] td[data-column="${columnIndex}"]`)
    }

    /**
     * Set cell element content based on its corresponding cell data object.
     * If the cell is a gap, make this an input cell if it wasn't already and apply a state to
     * depending on the showAnswer and isReadOnly flags.
     *
     * @param {Object} cell cell data
     * @param {Boolean} showAnswer show correct answer for this gap
     * @param {Boolean} isReadOnly if true, set cell input element to a disabled state
     */
    setCellElementContent(cell, showAnswer, isReadOnly) {
        const cellElement = this.getCellElement(cell.rowIndex, cell.columnIndex)
        if (cell.isGapCell) {
            const gapCellInput = cellElement.querySelector('input')
            if (!gapCellInput) {
                cellElement.outerHTML = InputCell({
                    cell,
                    cid: this.cid,
                })
                this.setCellElementContent(cell, showAnswer, isReadOnly)
                return
            }
            gapCellInput.disabled = isReadOnly
            cellElement.dataset.isGap = true
            if (showAnswer) {
                gapCellInput.checked = cell.cellText
            } else if (this.response) {
                const cellResponse = this.response.find(c => c.row === cell.rowIndex && c.column === cell.columnIndex)
                gapCellInput.checked = cellResponse?.text ?? false
            }
        } else {
            delete cellElement.dataset.gapType
            delete cellElement.dataset.isGap
            cellElement.innerHTML = Util.renderContentSafely(cell.cellText) || ''
        }
    }

    /**
     * Apply styling to the cell element based on the formattings array of corresponding cell data
     *
     * @param {Object} cell cell data
     */
    applyCellElementStyling(cell) {

        if (!Array.isArray(cell.formattings)) {
            return
        }

        const cellElement = this.getCellElement(cell.rowIndex, cell.columnIndex)

        // Remove existing classes and apply classes from formattings array
        cellElement.classList.remove(...cellElement.classList)
        for (const formatting of cell.formattings) {
            cellElement.classList.add(Styles[formatting])
        }

        if (cell.formattings.includes('is-merged')) {
            const previousCellElementInRow = this.getCellElement(cell.rowIndex, cell.columnIndex - 1)
            if (previousCellElementInRow) {
                previousCellElementInRow.colSpan = 2
            }
        }

    }
}
